module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-8-5d1a4329456a309de8c3476d4fd10cd1.jpg";